<template>
    <b-button
        variant="primary"
        @click="confirmarAprovacao()"
        :disabled="naoPodeAprovar"
        ><i class="fa fa-check-circle-o"></i> Aprovar</b-button
    >
</template>

<script>
export default {
    props: {
        comprometimento: {
            type: Object,
            default: () => ({})
        },

        dataServico: {
            type: Object,
            required: true,
            default: () => ({})
        },

        comprovacoes: {
            type: Object,
            default: () => ({})
        },

        avaliacoes: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarAprovacao() {
            this.$swal({
                title: 'Aprovar Serviço',
                html: `Confirma a aprovação do serviço <b>${this.comprometimento.idComprometimento}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.aprovar()
                }
            })
        },

        aprovar() {
            this.$store.dispatch('addRequest')
            let aprovacaoDto = {
                idComprometimento: this.comprometimento.idComprometimento,
                problemas: this.avaliacoes.problemas,
                avaliacoes: this.avaliacoes.avaliacoes
            }
            if (this.comprovacoes) {
                aprovacaoDto.comprovacao01 = this.comprovacoes.comprovacao01
                aprovacaoDto.comprovacao02 = this.comprovacoes.comprovacao02
            }
            this.dataServico
                .aprovarComprometimento(aprovacaoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Serviço aprovado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obter-atualizacao')
                        } else {
                            this.$toast.error(
                                'Erro ao aprovar serviço!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        naoPodeAprovar() {
            let semResposta = this.avaliacoes
                ? this.avaliacoes.avaliacoes.filter(item => {
                      return item.respostaId == 0
                  })
                : []
            let semComprovacao = this.comprovacoes
                ? this.comprometimento.contratoTipoEspecial &&
                  (this.comprovacoes.comprovacao01 == 0 ||
                      this.comprovacoes.comprovacao02 == 0)
                : this.comprometimento.contratoTipoEspecial
            return (
                (this.avaliacoes
                    ? this.avaliacoes.avaliacoes.length < 2
                    : true) ||
                semResposta.length > 0 ||
                semComprovacao ||
                !this.comprometimento.permiteAprovar
            )
        }
    }
}
</script>
